var chunkMapping = {
	"webpack_container_remote_mfeSales_Module": [
		9912
	],
	"webpack_container_remote_mfeSales_Login": [
		3479
	],
	"webpack_container_remote_mfeSales_AuthCallback": [
		2899
	],
	"webpack_container_remote_mfeTimesheet_Module": [
		8652
	],
	"webpack_container_remote_mfeProjects_Module": [
		896
	],
	"webpack_container_remote_mfeProjects_VerifyInvitation": [
		2826
	],
	"webpack_container_remote_mfeAdmin_Module": [
		9887
	],
	"webpack_container_remote_mfeSales_HomeDataProvider": [
		234
	],
	"webpack_container_remote_mfeSales_HomeWidgetWaitingOnTeams": [
		4785
	],
	"webpack_container_remote_mfeSales_HomeWidgetQuickActions": [
		5131
	],
	"webpack_container_remote_mfeSales_HomeWidgetQuotaPipeline": [
		7353
	],
	"webpack_container_remote_mfeSales_HomeWidgetRecentActivity": [
		2339
	],
	"webpack_container_remote_mfeTimesheet_HomeWidget": [
		993
	]
};
var idToExternalAndNameMapping = {
	"234": [
		"default",
		"./HomeDataProvider",
		8636
	],
	"896": [
		"default",
		"./Module",
		8646
	],
	"993": [
		"default",
		"./HomeWidget",
		4740
	],
	"2339": [
		"default",
		"./HomeWidgetRecentActivity",
		8636
	],
	"2826": [
		"default",
		"./VerifyInvitation",
		8646
	],
	"2899": [
		"default",
		"./AuthCallback",
		8636
	],
	"3479": [
		"default",
		"./Login",
		8636
	],
	"4785": [
		"default",
		"./HomeWidgetWaitingOnTeams",
		8636
	],
	"5131": [
		"default",
		"./HomeWidgetQuickActions",
		8636
	],
	"7353": [
		"default",
		"./HomeWidgetQuotaPipeline",
		8636
	],
	"8652": [
		"default",
		"./Module",
		4740
	],
	"9887": [
		"default",
		"./Module",
		5184
	],
	"9912": [
		"default",
		"./Module",
		8636
	]
};
var idToRemoteMap = {
	"234": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	],
	"896": [
		{
			"externalType": "script",
			"name": "mfeProjects"
		}
	],
	"993": [
		{
			"externalType": "script",
			"name": "mfeTimesheet"
		}
	],
	"2339": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	],
	"2826": [
		{
			"externalType": "script",
			"name": "mfeProjects"
		}
	],
	"2899": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	],
	"3479": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	],
	"4785": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	],
	"5131": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	],
	"7353": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	],
	"8652": [
		{
			"externalType": "script",
			"name": "mfeTimesheet"
		}
	],
	"9887": [
		{
			"externalType": "script",
			"name": "mfeAdmin"
		}
	],
	"9912": [
		{
			"externalType": "script",
			"name": "mfeSales"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"234": {
		"shareScope": "default",
		"name": "./HomeDataProvider",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	},
	"896": {
		"shareScope": "default",
		"name": "./Module",
		"externalModuleId": 8646,
		"remoteName": "mfeProjects"
	},
	"993": {
		"shareScope": "default",
		"name": "./HomeWidget",
		"externalModuleId": 4740,
		"remoteName": "mfeTimesheet"
	},
	"2339": {
		"shareScope": "default",
		"name": "./HomeWidgetRecentActivity",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	},
	"2826": {
		"shareScope": "default",
		"name": "./VerifyInvitation",
		"externalModuleId": 8646,
		"remoteName": "mfeProjects"
	},
	"2899": {
		"shareScope": "default",
		"name": "./AuthCallback",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	},
	"3479": {
		"shareScope": "default",
		"name": "./Login",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	},
	"4785": {
		"shareScope": "default",
		"name": "./HomeWidgetWaitingOnTeams",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	},
	"5131": {
		"shareScope": "default",
		"name": "./HomeWidgetQuickActions",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	},
	"7353": {
		"shareScope": "default",
		"name": "./HomeWidgetQuotaPipeline",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	},
	"8652": {
		"shareScope": "default",
		"name": "./Module",
		"externalModuleId": 4740,
		"remoteName": "mfeTimesheet"
	},
	"9887": {
		"shareScope": "default",
		"name": "./Module",
		"externalModuleId": 5184,
		"remoteName": "mfeAdmin"
	},
	"9912": {
		"shareScope": "default",
		"name": "./Module",
		"externalModuleId": 8636,
		"remoteName": "mfeSales"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}